// 空気の衝撃波 (既定・旧は DEV ?roarAir=0・src/exec_roar_air.ts) の当たりの形。hits.ts (当たり)・render (見た目)・bot が同じ式を読む。
//
//   波はボスの中心 (溜めの頭の位置) から左右へ同じ速さで広がる。前縁 = 中心から半径 r の所 (左右2か所)。
//   当たるのは前縁の厚み (thicknessPx) が主人公の体 (幅 PLAYER.width) に重なった一瞬だけ (hitOnce)。
//   届く範囲 reachPx は「ボスの中心から主人公の中心まで」の距離。これより遠い主人公には触れない
//   (前縁は reachPx − 主人公の半幅 で止まり、その時刻で消える)。
import { PLAYER } from './balance'
import type { AirWaveSpec } from './types'

type AirHit = { elapsedMs: number; telegraphMs: number; airWave: AirWaveSpec & { originX: number } }

/** 前縁が止まる半径 (= 届く範囲の端に立つ主人公の体の内側の縁)。 */
export function airWaveEdgePx(spec: AirWaveSpec): number {
  return spec.reachPx - PLAYER.width / 2
}

// 前縁が端に着いた tick を必ず1回は当たりとして数えるための余り (1 tick ぶん)。
const EDGE_HOLD_MS = 17

/** 当たりの続く長さ (出てから前縁が端に着くまで + 1 tick)。 */
export function airWaveActiveMs(spec: AirWaveSpec): number {
  return Math.ceil(airWaveEdgePx(spec) / spec.speedPxPerSec * 1000) + EDGE_HOLD_MS
}

/** いまの前縁の半径 (px)。出る前は 0、端に着いたら端で止める。 */
export function airWaveRadiusPx(hit: AirHit): number {
  const t = Math.max(0, hit.elapsedMs - hit.telegraphMs)
  return Math.min(airWaveEdgePx(hit.airWave), hit.airWave.speedPxPerSec * t / 1000)
}

/** 前縁 (半径 r − 厚み 〜 r) が主人公の体に重なっているか。 */
export function airWaveOverlapsPlayer(hit: AirHit, playerX: number): boolean {
  const r = airWaveRadiusPx(hit)
  const d = Math.abs(playerX - hit.airWave.originX)
  const half = PLAYER.width / 2
  return d - half <= r && d + half >= r - hit.airWave.thicknessPx
}

/**
 * いまの位置に立ったままなら、あと何 ms で前縁が体に触れるか。もう重なっていれば 0。
 * 通り過ぎた・届く範囲の外なら Infinity。
 */
export function airWaveContactEtaMs(hit: AirHit, playerX: number): number {
  const d = Math.abs(playerX - hit.airWave.originX)
  const half = PLAYER.width / 2
  const need = Math.max(0, d - half)
  if (need > airWaveEdgePx(hit.airWave)) return Infinity
  const wait = Math.max(0, hit.telegraphMs - hit.elapsedMs)
  const r = airWaveRadiusPx(hit)
  if (r - hit.airWave.thicknessPx > d + half) return Infinity
  if (r >= need) return wait
  return wait + (need - r) / hit.airWave.speedPxPerSec * 1000
}
